module.exports = __webpack_public_path__ + "img/perfect.3f688c26.png";